import { Notify } from 'quasar';

// Allows us to custom style Quasar's notifications
export type NotificationOptions =
  | string
  | {
      type?: 'success' | 'error' | 'info' | 'warning';
      message: string;
      timeout?: number;
      html?: boolean;
    };
export const genericErrorMessage =
  'An error occurred, please try again later. If the error persists, please contact customer support.';

/**
 * Extracts a user-friendly error message from an unknown error object.
 * Handles axios-style errors, standard Error objects, and string errors.
 */
export function getErrorMessage(error: unknown): string {
  // Handle axios-style errors with response.data.message
  if (
    typeof error === 'object' &&
    error !== null &&
    'response' in error &&
    typeof (error as Record<string, unknown>).response === 'object'
  ) {
    const response = (error as Record<string, unknown>).response as Record<
      string,
      unknown
    >;
    if (
      typeof response.data === 'object' &&
      response.data !== null &&
      'message' in response.data &&
      typeof (response.data as Record<string, unknown>).message === 'string'
    ) {
      return (response.data as Record<string, unknown>).message as string;
    }
  }

  // Handle standard Error objects
  if (error instanceof Error) {
    return error.message;
  }

  // Handle string errors
  if (typeof error === 'string') {
    return error;
  }

  return genericErrorMessage;
}
export default (options: NotificationOptions) => {
  if (typeof options === 'string') {
    return Notify.create({
      message: options,
      icon: `img:/icons/green-check-circle.svg`,
      timeout: 3000,
      position: 'top',
      classes: `ds-notification ds-notification-success`,
    });
  } else {
    const iconName =
      options.type === 'success'
        ? 'green-check-circle'
        : options.type === 'error'
        ? 'red-x-circle'
        : options.type === 'info'
        ? 'blue-info-circle'
        : options.type === 'warning'
        ? 'yellow-exclamation-triangle'
        : 'green-check-circle';
    const type = options.type || 'success';
    return Notify.create({
      message: options.message,
      icon: `img:/icons/${iconName}.svg`,
      timeout:
        options.timeout || options.timeout === 0 ? options.timeout : 3000,
      position: 'top',
      classes: `ds-notification ds-notification-${type}`,
      html: options.html || false,
    });
  }
};
